<div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden">
    <div class="flex items-center m-6 mb-0">
        <div class="text-xl font-medium tracking-tight leading-6 truncate ">{{title}}</div>
        <mat-icon
                class="ml-1.5 icon-size-4 text-hint"
                [svgIcon]="'heroicons_solid:information-circle'"
                [matTooltip]="'la percentuale è calcolata come variazione percentuale tra il numero di application pervenute in data odierna rispetto al giorno precedente'"></mat-icon>
    </div>
    <div class="flex lg:flex-row lg:items-center mx-6 mt-3">
        <span class="text-7xl font-bold tracking-tighter leading-tight "

        >{{appNumber | number:'1.0-0'}}</span>
        <div class="flex items-center ml-2">
            <mat-icon
                    *ngIf="parsedDifference > 0"

                    class="icon-size-5 text-green-500"
                    [svgIcon]="'heroicons_solid:arrow-circle-up'"></mat-icon>
            <mat-icon
                    *ngIf="parsedDifference < 0"
                    class="icon-size-5 text-red-500"
                    [svgIcon]="'heroicons_solid:arrow-circle-down'"></mat-icon>
            <mat-icon
                    *ngIf="parsedDifference === 0"
                    class="icon-size-5 text-accent-400"
                    [svgIcon]="'heroicons_solid:minus-circle'"></mat-icon>

            <div class="ml-1 text-md font-medium "
                 [ngClass]="{'text-accent-400' : parsedDifference === 0,
                 'text-green-500' : parsedDifference > 0,
                 'text-red-500' : parsedDifference < 0}">
                {{parsedDifference}}%
            </div>
        </div>
        <!--                    <div class="flex lg:flex-col lg:ml-3">-->
        <!--                        <mat-icon-->
        <!--                                class="icon-size-5 text-red-500"-->
        <!--                                [svgIcon]="'heroicons_solid:trending-down'"></mat-icon>-->
        <!--                        <div class="flex items-center ml-1 lg:ml-0 lg:mt-0.5 text-md leading-none whitespace-nowrap text-secondary">-->
        <!--                            <span class="font-medium text-red-500">2%</span>-->
        <!--                            <span class="ml-1">below target</span>-->
        <!--                        </div>-->
        <!--                    </div>-->
    </div>
    <div class="flex flex-col flex-auto h-20">
        <apx-chart
                class="flex-auto w-full h-full"
                [chart]="chartConversions?.chart"
                [colors]="chartConversions?.colors"
                [series]="chartConversions?.series"
                [stroke]="chartConversions?.stroke"
                [tooltip]="chartConversions?.tooltip"
                [xaxis]="chartConversions?.xaxis"
                [yaxis]="chartConversions?.yaxis"></apx-chart>
    </div>
</div>
